import { PlatformItemType } from "../../../../../../../../../stores/types/profileTypes.tsx";
import { platformIconData } from "./data.tsx";
import { RevTooltip } from "@revmatics/catalyst";

type Props = {
  platform: PlatformItemType;
  selected: boolean;
  handleSelect: () => void;
  disabled?: boolean;
  disabledExistUsername?: boolean;
};

export const PlatformIconWrapper = ({
  platform,
  selected,
  handleSelect,
  disabled,
  disabledExistUsername,
}: Props) => {
  const icons = platformIconData[platform.name.toLowerCase()];
  const disabledResult = disabled || (disabledExistUsername && !selected);

  const tooltipContent = (
    <div className="flex flex-col gap-0.5">
      <p>{platform.name}</p>
      {disabledResult && (
        <span className="typography-body-bold-xs text-monochrome-600">
          {disabled
            ? "This platform has already been selected"
            : "There is already a valid username"}
        </span>
      )}
    </div>
  );

  return (
    <RevTooltip
      content={tooltipContent}
      position="top"
      className="max-w-[240px]"
    >
      <button
        disabled={disabledResult}
        type="button"
        onClick={() => !selected && handleSelect()}
        className={`
          group w-8 h-8 rounded-lg border p-1 flex justify-center items-center
          transition-colors relative
          ${
            disabledResult
              ? "border-monochrome-100"
              : selected
                ? "border-primary-500"
                : "border-monochrome-400 hover:border-primary-500"
          }
        `}
      >
        {/* default */}
        {!disabledResult && !selected && (
          <img
            src={icons.default}
            alt={platform.name}
            className="h-6 w-auto group-hover:hidden"
          />
        )}

        {/* hover */}
        {!disabledResult && !selected && icons.hover && (
          <img
            src={icons.hover}
            alt={platform.name}
            className="h-6 w-auto hidden group-hover:block"
          />
        )}

        {/* selected */}
        {selected && (
          <img
            src={icons.selected}
            alt={platform.name}
            className="h-6 w-auto"
          />
        )}

        {/* disabled */}
        {disabledResult && (
          <img
            src={icons.disabled}
            alt={platform.name}
            className="h-6 w-auto"
          />
        )}
      </button>
    </RevTooltip>
  );
};
